import React from 'react';
import { XSocialCircle } from 'components/SocialCircle';
import SocialButton, { SocialButtonProps } from './SocialButton';

export interface TwitterButtonProps
  extends Pick<
    SocialButtonProps,
    'disabled' | 'onClick' | 'params' | 'size' | 'tooltip'
  > {}

const TwitterButton: React.FC<TwitterButtonProps> = ({
  disabled,
  onClick,
  size,
  tooltip,
}) => (
  <SocialButton
    icon={<XSocialCircle />}
    label="X (Twitter)"
    {...{ disabled, onClick, size, tooltip }}
  />
);

export default TwitterButton;
